import {
    EMAIL_FORMAT_INVALID,
    STATUS_INVALID,
    ROLE_ID_INVALID,
    FRANCHISEE_ID_INVALID,
    ACCOUNT_ALREADY_EXISTS,
} from 'constants/admin';

const admin = {
    account: 'Account',
    name: 'Name',
    role_name: 'Role',
    franchisee_name: 'Franchisee',
    new_user: 'New',
    remove: 'Remove',
    role: 'Role',
    franchisee: 'Franchisee',
    update_user: 'Edit User',
    update_users: 'Edit Users',
    confirm_remove: 'Delete users:',
    [`update_user_error_message_${ EMAIL_FORMAT_INVALID }`]: 'Email format invalid',
    [`update_user_error_message_${ STATUS_INVALID }`]: 'Status invalid',
    [`update_user_error_message_${ ROLE_ID_INVALID }`]: 'Role id invalid',
    [`update_user_error_message_${ FRANCHISEE_ID_INVALID }`]: 'Franchisee id invalid',
    [`update_user_error_message_${ ACCOUNT_ALREADY_EXISTS }`]: 'Account already exists',
    account_disabled_title: 'Re-Add Account',
    account_disabled_message: 'This account was removed. Are you sure you want to add it back again?'
};

export default admin;
